import React from "react";
import "./Header.css";
import AppIcon from "../../assets/images/app-icon/H891KDT0.png";
import { v4 as uuidv4 } from "uuid";

const Header = () => {
  return (
    <div>
      <header className="header">
        <div className="logo">
          <a href="/">
            <img src={AppIcon} className="icon" alt={uuidv4()} />
          </a>{" "}
          Coffee Focus
        </div>
        <nav>
          <ul>
            <li>
              <a
                href="https://apps.apple.com/app/id6745236653"
                target="_blank"
                rel="noreferrer"
              >
                Download
              </a>
            </li>
            <li>
              <a href="mailto:talalzeini+coffeefocus@icloud.com">Contact</a>
            </li>
          </ul>
        </nav>
      </header>
    </div>
  );
};

export default Header;
